/**
 * The web modules that hold UI interaction rows (test strategy section 7): the Phase 1 web modules
 * (1.0b deliverable 15), then the import and saved-view modules of Phase 2a (CS r4a, r4b), then the
 * sessions, run, after (CS r5a), bootstrap and undo (CS r5b) and review modules of later phases,
 * then Phase 2c's foundry and two sheets modules (CS r6c).
 */
export const UI_MODULES = [
    'web/shell',
    'web/nav',
    'web/documents',
    'web/links',
    'web/types',
    'web/templates',
    'web/history',
    'web/trash',
    'web/read',
    'web/inbox',
    'web/catalogue',
    'web/when',
    'web/chronicle',
    'web/calendar',
    'web/ledger',
    'web/reference',
    'web/sheet-form',
    'web/import',
    'web/views',
    'web/sessions',
    'web/run',
    // CS r5a (deliverable 149): After, the session page's tab (2.F).
    'web/after',
    // CS r5b (deliverable 165): the bootstrap wizard (2.J) and the Undo toast (2.L).
    'web/bootstrap',
    'web/undo',
    'web/review',
    // CS r6c (deliverable 205): Phase 2c's Foundry import (2.I-2), PC sheet (2.H) and cards (2.M).
    'web/foundry',
    'web/sheets/pc',
    'web/sheets/cards',
];
/** Keeps each module file's literal rows checked against {@link UiInteractionRow}. */
export function uiRows(rows) {
    return rows;
}
//# sourceMappingURL=types-def.js.map